import Vue from "vue";
import Vuex from "vuex";
import { denemePlugin } from "../plugins/account";

// import UserLogin from '../api/SystemUsers/UserLogin';
import User from "../api/User";
import Widget from "../api/Widget";
import Language from "../api/Language";
import Controller from "../api/Controller";
import Router from "../api/Router";
import Option from "../api/Option";
import Module from "../api/Module";
import Urunler from "../api/Urunler";
import Kullanicilar from "../api/Kullanicilar";
import Siparisler from "../api/Siparisler";
import Media from "../api/Media";
import Sayfalar from "../api/Sayfalar";
import Yazilar from "../api/Yazilar";
import Slider from "../api/Slider";
import Destek from "../api/Destek";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    breadCrumbs: [],
    loadingStatus: true,
    systemTree: JSON.parse(localStorage.getItem("system_tree") ?? "{}") || [],
    panelNavigation:
      JSON.parse(localStorage.getItem("system_tree") ?? "{}")
        .panel_navigation || [],
    panelNavigationExtend:
      JSON.parse(localStorage.getItem("system_tree") ?? "{}")
        .panel_navigation_1_extend || [],
    panelSettings:
      JSON.parse(localStorage.getItem("system_tree") ?? "{}").panel_settings ||
      [],
    routes: [],
    activeBreadCrumbs: [],
  },
  getters: {
    /**
     * İlgili navigasyonu sistem ağacı üzerinden bulur
     * ve getirir
     */
    getNav: (state) => (navName) => {
      return state.systemTree[navName] || [];
    },
    /**
     * Sistemdeki öntanımlı navigasyon üzerinden ilgili
     * navigasyonu getirir
     *
     * @param {string}
     */
    getSettingsNav: (state) => (navName) => {
      let navs = navName.split("/");

      function getNav(nav, navItems) {
        if (typeof navItems[nav] !== undefined) {
          return navItems[nav];
        } else {
          return null;
        }
      }

      function getChild(navItems) {
        if (typeof navItems.child !== undefined) {
          return navItems.child;
        } else {
          return null;
        }
      }

      let navigation,
        item = state.panelSettings.child;
      navs.forEach((nav) => {
        navigation = getNav(nav, item);
        item = getChild(navigation);
      });

      let navList = navigation.child;

      for (let n in navList) {
        navList[n].links = navName;
      }

      return navList;
    },
  },
  mutations: {
    setLoadingStatus: (state, value) => {
      state.loadingStatus = value;
    },
    setBreadCrumbs: (state, data) => {
      state.breadCrumbs = data;
    },
    setRoute: (state, value) => {
      state.routes.push(value);
    },
    setActiveBreadcrumbs: (state, value) => {
      state.activeBreadCrumbs = value;
    },
  },
  actions: {
    setRoutes: ({ commit }, routes) => {
      let nav = [];
      // let imp = (view) => {
      //   return import('@/views/' + view)
      // }
      Object.keys(routes).forEach((key) => {
        if (routes[key].link !== "" && routes[key].view) {
          let view =
            "@/views/" +
            ("@/views/" + routes[key].view !== ""
              ? routes[key].view
              : "404NotFound.vue");
          // console.log(() => (resolve) => require([`@/views/${view}`], resolve));
          let navData = {
            path: routes[key].link,
            name: routes[key].name,
            meta: { title: routes[key].name },

            component: () => (resolve) => require([`@/views/${view}`], resolve),
            // component: () => import('@/views/'+routes[key].view !== '' ? routes[key].view : '404NotFound.vue'),
            // children: Object.keys(routes[key].child).length > 0 ? dispatch('setRoutes', routes[key].child) : []
          };
          commit("setRoute", navData);
        }
      });
      return nav;
    },
  },
  modules: {
    User,
    Widget,
    Language,
    Controller,
    Router,
    Option,
    Module,
    Urunler,
    Kullanicilar,
    Siparisler,
    Media,
    Sayfalar,
    Yazilar,
    Slider,
    Destek
  },
  plugins: [denemePlugin],
});

// const store = new Vuex.Store({ /* options */ })

// store.registerModule('createPlugin', {
//   // ...
// })
